import { Box, Grid, IconButton, Stack, Typography, useTheme } from "@mui/material";
import { useCallback, useState } from "react";
import {useDropzone} from 'react-dropzone';
import { useTranslation } from "react-i18next";
import ClearIcon from '@mui/icons-material/Clear';

// https://www.npmjs.com/package/react-dropzone

const FileUploadComponent = ({
    label,
    allowedFiles=[],
    required=false,
    error=null,
    setError,
    selectedFile,
    setFile
}) => {
    const theme = useTheme();
    const {t} = useTranslation();

    const onDrop = useCallback(acceptedFiles => {
        acceptedFiles.forEach((file) => {
            console.log(file.type);

            if(!allowedFiles.includes(file.type)){
                setError(t('form.fileUpload.invalid'));
                return;
            }

            setError(null);

            const reader = new FileReader()

            reader.onabort = () => console.log('file reading was aborted');
            reader.onerror = () => console.log('file reading has failed');

            reader.onload = () => {
                setFile(file);
            }

            reader.readAsArrayBuffer(file);
        });
    }, [allowedFiles]);

    const clearFiles = useCallback(() => {
        setFile(null);
    }, []);

    const {getRootProps, getInputProps, isDragActive} = useDropzone({onDrop});

    return (
        <>
            <Stack
                direction='column'
                justifyContent='start'
                alignItems='start'
                width='100%'
                py={2}
            >
                <Typography
                    fontWeight={600}
                    fontSize={{xs: 12, md: 14, lg: 16}}
                    textAlign="left"
                    lineHeight={1.5}
                    color={theme.palette.text.primary}
                    pb={2}
                >
                    {required ? `${label} *` : label}
                </Typography>
            
                <div {...getRootProps()} style={{width: '100%'}}>
                    <input {...getInputProps()} />

                    <Box
                        sx={{
                            backgroundColor: theme.palette.background.paper,
                            py: 10,
                            width: '100%',
                            borderRadius: 4,
                            border: `1.5px dashed ${!error ? theme.palette.text.primary : 'rgba(211, 48, 47, 1)'}`
                        }}
                    >
                        {
                            isDragActive
                            ?
                            <Typography
                                fontWeight={500}
                                fontSize={{xs: 12, md: 14, lg: 16}}
                                textAlign="center"
                                lineHeight={1.5}
                                color={!error ? theme.palette.text.secondary : 'rgba(211, 48, 47, 1)'}
                                px={2}
                            >
                                {t('form.fileUpload.dropHere')}
                            </Typography>
                            :
                            <Typography
                                fontWeight={500}
                                fontSize={{xs: 12, md: 14, lg: 16}}
                                textAlign="center"
                                lineHeight={1.5}
                                color={!error ? theme.palette.text.secondary : 'rgba(211, 48, 47, 1)'}
                                px={2}
                            >
                                {t('form.fileUpload.default')}
                            </Typography>
                        }
                    </Box>
                </div>

                {/* Uploaded File */}
                {
                    selectedFile?.name
                    ?
                    <Grid
                        direction='row'
                        justifyContent='space-between'
                        alignItems='center'
                        spacing={2}
                        pt={1}
                        container
                        width='100%'
                    >
                        <Grid size={10}>
                            <Typography
                                fontWeight={500}
                                fontSize={{xs: 12, md: 12, lg: 12}}
                                textAlign="left"
                                lineHeight={1.5}
                                color={theme.palette.text.secondary}
                                pl={1}
                                sx={{
                                    wordWrap: 'break-word'
                                }}
                            >
                                {selectedFile?.name}
                            </Typography>
                        </Grid>

                        <Grid 
                            size={2}
                            display='flex'
                            direction='row'
                            justifyContent='end'
                            alignItems='center'
                        >
                            <IconButton 
                                aria-label="delete"
                                onClick={clearFiles}
                            >
                                <ClearIcon />
                            </IconButton>
                        </Grid>
                    </Grid>
                    :
                    <></>
                }

                {/* Error */}
                {
                    error
                    ?
                    <Typography
                        fontWeight={500}
                        fontSize={{xs: 12, md: 12, lg: 12}}
                        textAlign="left"
                        lineHeight={1.5}
                        color='rgba(211, 48, 47, 1)'
                        pt={1}
                        pl={1}
                    >
                        {error}
                    </Typography>
                    :
                    <></>
                }
            </Stack>
        </>
    );
}

export default FileUploadComponent;